/**
 * @author caijianjia
 * @date 2020/4/8 10:35 上午
 */


let lastExecuteTime = 0
let Vuex = null
export const setUtilsVuex = a => {
  Vuex = a;
  return Vuex;
};

/**
 * 是否为空
 */
export const isNull = (v) => {
  switch (typeof v) {
  case 'undefined':
      return true;
  case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
      break;
  case 'boolean':
      if (!v) return true;
      break;
  case 'number':
      if (0 === v || isNaN(v)) return true;
      break;
  case 'object':
      if (null === v || v.length === 0) return true;
      for (var i in v) {
          return false;
      }
      return true;
  }
  return false;
};

/**
 * 是否连续快速执行两次方法
 * @param time  延迟时间
 * @returns {boolean}
 */
export const isFastExecute = (time = 500) => {
  if (Date.now() - lastExecuteTime < time) {
    return true;
  }
  lastExecuteTime = Date.now();
  return false;
};

// 获取当前时间戳
export function getCurDateTime() {
    return Date.parse(new Date())
}

/**
 * 将数组转乘 key value children 格式
 * @param arr
 */
export function FormatData (arr) {
  let obj = {}
  return arr.map(v => {
    obj = {
      key: `${v.id}`,
      value: v.name
    }
    if (v.childrens && v.childrens.length > 0) {
      obj.children = getNewChilrens(v.childrens)
    }
    return {
      ...obj,
      ...v
    }
  })
}
/**
 * 递归获取所有子节点的数据
 * @param data 数组
 * */
export function getNewChilrens (data) {
  let obj = {}
  return data.map(v => {
    obj = {
      key: `${v.id}`,
      value: v.name
    }
    if (v.childrens && v.childrens.length > 0) {
      obj.children = getNewChilrens(v.childrens)
    }
    return obj
  })
}

/**
 * 所有数据 将书名和单元合并成所有数组
 * @param arr
 */
export function bookAndUnit (books, units) {
  let newArr = books
  if(Array.isArray(newArr) && Array.isArray(units)) {
    newArr.map(v=>{
      units.map(q=>{
        if(`${q.book_id}` === `${v.key}`){
          v.children.push(q)
        }
      })
    })
  }
  return newArr
}

/**
 * 单元 将数组转乘 key value children 格式
 * @param arr
 */
export function unit2Tree (arr) {
  let obj = {}
  if(Array.isArray(arr)) {
    return arr.map(v => {
      obj = {
        key: `${v.id}`,
        value: v.unit,
        book_id: v.book_id
      }
      if (v.chapters && v.chapters.length > 0) {
        obj.children = getNewUnitChilrens(v.chapters)
      }
      return {
        ...obj
      }
    })
  }else{
    return []
  }
}
/**
 * 单元 递归获取所有子节点的数据
 * @param data 数组
 * */
export function getNewUnitChilrens (data) {
  let obj = {}
  return data.map(v => {
    obj = {
      key: `${v.id}`,
      value: v.chapter_name
    }
    if (v.chapters && v.chapters.length > 0) {
      obj.children = getNewUnitChilrens(v.chapters)
    }
    return obj
  })
}

/***
 * 通过attr获取当前编辑的对象
 * @param attr 字段唯一标识
 * @param data 当前所有字段
 */
export function getObjByAttr ({ attr, data }) {
  let obj = {}
  data.map(v => {
    if (`${v.attr}` === `${attr}`) {
      obj = v
    }
  })
  return obj
}

/**
 * 获取路径中的md5值
 * @param value 全路径
 * */
export function getMd5 (value) {
  let newValue = value
  try {
    newValue = newValue.match(/[0-9a-fA-F]{32}/g)
    if ( Array.isArray(newValue) ) {
      newValue = newValue[0]
    }
  } catch (e) {
    console.log('转换失败==>', e)
  }
  return newValue
}

/***
 * 通过attr获取当前编辑的对象的索引
 * @param attr 字段唯一标识
 * @param data 当前所有字段
 */
export function getIndexByAttr ({ attr, data }) {
  let index = -1
  data.map((v, i) => {
    if (`${v.attr}` === `${attr}`) {
      index = i
    }
  })
  return index
}

/***
 * 将自定义组件的值转换成表单标准格式
 * @param obj 当前所有字段
 */
export function getArrByDiy ({ obj }) {
  const newObj = obj
  const arr = []
  if (newObj) {
    let temp = JSON.parse(newObj).layout
    temp = temp.filter(v => v.config)
    temp.map(v => {
      arr.push(v.config[0])
    })
  }
  console.log('arr==>', arr)
  if (arr && arr.length > 0) {
    return arr
  }
  return newObj
}

/**
 * 获取所有有attr属性的字段值
 * @param data 数组
 * */
export function getObjByArr({data}) {
  let newData = data
  let obj = {}
  try {
    newData.map(v => {
      if (v.attr) {
        obj[v.attr] = v.value
      }
    })
  }catch (e) {
    console.log('utils->转换失败==>', e)
  }
  return obj
}

/**
 * 给树节点每个节点加上父级id
 * @param data 整颗树数据
 */
export function setParentId(data) {
  let newData = data
  let rev = (data, id) => {
    if(id){
      data.map(v=>{
        v.parent_id = id
        if(v.childrens && v.childrens.length){
          rev(v.childrens, v.id)
        }
      })
    } else {
      data.map(v=>{
        if(v.childrens && v.childrens.length){
          rev(v.childrens, v.id)
        }
      })
    }
  }
  rev(newData)
  return newData
}

/**
 * 获取节点的所有父级节点
 * @param data2 整个树
 * @param nodeId2 某节点的id
 * */
export function getParentNode(data2, nodeId2) {
  let arrRes = [];
  if (data2.length == 0) {
    if (nodeId2) {
      arrRes.unshift(data2)
    }
    return arrRes;
  }
  let rev = (data, nodeId) => {
    for (let i = 0, length = data.length; i < length; i++) {
      let node = data[i];
      if (node.id == nodeId) {
        arrRes.unshift(node)
        rev(data2, node.parent_id);
        break;
      } else {
        if (node.childrens) {
          rev(node.childrens, nodeId);
        }
      }
    }
    return arrRes;
  };
  arrRes = rev(data2, nodeId2);
  return arrRes;
}

/**
 * 获取视频第一帧画面
 * @param eleVideo 当前视频元素
 * @param eleTarget 第一帧渲染到当前元素内
 * @param imgWidth 图片渲染宽度
 * @param imgHeight 图片渲染高度
 * */
export function getVideoFirstImg ({ eleVideo, eleTarget, imgWidth = 400, imgHeight = 300 }) {
  const canvas = document.createElement('canvas')
  const img = document.createElement('img')
  eleVideo.setAttribute('crossOrigin', 'anonymous')
  canvas.width = eleVideo.clientWidth
  canvas.height = eleVideo.clientHeight
  eleVideo.onloadeddata = () => {
    canvas.getContext('2d').drawImage(eleVideo, 0, 0, canvas.width, canvas.height)
    const dataURL = canvas.toDataURL('image/png')
    img.src = dataURL
    img.width = imgWidth
    img.height = imgHeight
    eleTarget.appendChild(img)
  }
}

/**
 * 获取html路径中的md5值
 * @param value 全路径
 * */
export function getHtmlMd5 (value) {
  let newValue = value
  try {
    const arr = newValue.split('.com/')
    let calcValue = arr[1]
    if (calcValue.indexOf('/index.html') > -1) {
      calcValue = calcValue.replace('/index.html', '')
    } else if (calcValue.indexOf('.html') > -1) { calcValue = calcValue.replace('.html', '') }
    newValue = calcValue
  } catch (e) {
    console.log('转换失败==>', e)
  }
  return newValue
}

/**
 * 获取html地址
 * @param value 全路径 【xxx/index.html】
 * */
export function getHtml (value) {
  let newValue = value
  try {
    if (newValue.indexOf('.com/')) {
      const arr = newValue.split('.com/')
      let calcValue = arr[1]
      if (calcValue.indexOf('/index.html') > -1) { calcValue = calcValue.replace(('/index.html', '.index.html')) }
      newValue = calcValue
    }
  } catch (e) {
    console.log('转换失败==>', e)
  }
  return newValue
}

/**
 * 获取所有匹配到的md5
 * @param data 需要匹配的数据
 * @param reg 正则规则
 * */
export function getAllMd5({data, reg = /[0-9a-fA-F]{32}/gi}){
  let newData =  data
  if(typeof newData !== 'string'){
    newData = JSON.stringify(newData)
  }
  return newData.match(reg)
}

/**
 * 生成对应的md5值
 * @param value 需要转md5的字符串
 * */
export function getMd5ById(value) {
  let newValue = value
  return newValue
}

/**
 * 在对象中生成一个随机字段
 * @param value 课件配置
 * */
export function getRandomByObj(obj) {
  let newObj = obj
  if(!newObj) return newObj || {}
  try {
    if(!newObj.unique){
      let date=new Date();
      let datetime=date.getFullYear()+""+date.getMonth()+""+date.getDate()+""+date.getHours()+""+date.getMinutes()+""+date.getSeconds();
      newObj.unique = "les_"+datetime+"_"+Math.floor(Math.random()*999999);
    }
  }catch (e) {
    console.log('设置随机标识失败==>', e)
  }
  return newObj
}

/**
 * 在对象中生成一个随机字段 (覆盖)
 * @param value 课件配置
 * */
export function getRandomOverByObj(obj) {
  let newObj = obj
  try {
    let date=new Date();
    let datetime=date.getFullYear()+""+date.getMonth()+""+date.getDate()+""+date.getHours()+""+date.getMinutes()+""+date.getSeconds();
    newObj.unique = "les_"+datetime+"_"+(Math.floor(Math.random()*(9999-1000))+1000);
  }catch (e) {
    console.log('设置随机标识失败==>', e)
  }
  return newObj
}

/**
 * 在对象中修改某个key
 * @param obj 当前要修改的obj
 * @param path 所有key入境
 * @param item 编辑内容
 * */
export function putObject(obj, path, item) {
  let newObj = obj
  try {
    let newPath = path.replace(/\//g, '.')
    let arr = newPath.match(/([^\\.]+)/g)
    arr && arr.map(v => {
      newPath = newPath.replace(eval('/\\.' + v + '/i'), `['${v}']`)
    })
    let newItem = item
    if (typeof newItem === 'object') {
      newItem = JSON.stringify(item)
    } else if (typeof newItem === 'string') {
      newItem = newItem.replace(/"/g, "'")
      newItem = `\`${newItem}\``
    }
    //console.log('999=>', typeof newItem, `newObj${newPath}=${newItem};`)
    // debugger

    eval(`newObj${newPath}=${newItem};`)
  }catch (e) {
    console.log('设置失败==>', e)
  }
  return newObj
}

/**
 * 在对象中删除修改某个key
 * @param obj 当前要修改的obj
 * @param path 所有key入境
 * */
export function deleteObject(obj, path) {
  let newObj = obj
  try {
    let newPath = path.replace(/\//g, '.')
    let arr = newPath.match(/([^\\.]+)/g)
    arr && arr.map(v => {
      newPath = newPath.replace(eval('/\\.' + v + '/i'), `['${v}']`)
    })
    eval(`delete newObj${newPath}`)
  }catch (e) {
    console.log('删除失败1==>', e)
  }
  return newObj
}

/**
 * 获取新的地址
 * @param url地址
* */
export function getNewUrl(url) {
  let newUrl = url
  if(newUrl.length>200) return url
  if(newUrl.indexOf(`?`)>-1){
    newUrl += `&${Math.random()}`
  }else{
    newUrl += `?${Math.random()}`
  }
  return newUrl
}

/**
 * 获取明天的GMT时间戳
 * */
export function getNextDay () {
  const day = new Date()
  return day.setTime(day.getTime() + 24 * 60 * 60 * 1000)
}

// 获取当前选中节点 - 菜单选中节点
export function curSelectedNode({
  data,
  unique,
  type,
  updateData
}){
  let newData = data || Vuex.state.menusData.blocksForm
  let newUnique = unique || Vuex.state.menusData.blocksSelected
  //console.log('curSelectedNode==>'+`[${new Date().getTime()}]`, newData, newUnique)
  //console.warn('------------------------------------------------')
  let node = null
  for(let i = 0, len = newData.length; i<len; i++){
    if(`${newData[i].unique}` === `${newUnique}`){
      node = newData[i]
      // type
      // 删除delete 返回删除的索引，当前索引的新unique,如果没有取上一个
      // 修改update 返回修改后的节点
      // 当前节点结构 select 返回当前节点，当前索引
      let index = i
      switch (type) {
        case 'delete': {
          let unique = newData[index] && newData[index].unique
          node = {
            unique,
            deleteIndex: index,
            deleteNode: node
          }
          newData.splice(index, 1)
          console.log("删除delete 返回删除的索引，当前索引的新unique,如果没有取上一个");
          break
        }
        case 'update': {
          newData[index] = updateData
          node = newData[index]
          console.log("修改update 返回修改后的节点");
          break
        }
        case 'select': {
          let unique = newData[index] && newData[index].unique
          node = {
            unique,
            index,
            node
          }
          console.log("当前节点结构 select 返回当前节点，当前索引");
          break
        }
      }
      break
    } else if(newData[i].leaf && newData[i].leaf.length > 0 && !node) {
      node = setNode({arr:newData[i].leaf, node, unique: newUnique,type,updateData})
      console.log("节点结构:",node);
   }
  }
  //console.log('Vuex.state.menusData===>>>',Vuex.state.menusData)
  return node
}
export function setNode({arr, node, unique, type, updateData}){
  let newNode = node
  let index = -1
  for(let i=0, len = arr.length; i<len; i++){
    // console.log('unique==>', arr[i].unique, unique, i, arr[i].name)
    if(`${arr[i].unique}` === `${unique}`){
      newNode = arr[i]
      index = i
      // type
      // 删除delete 返回删除的索引，当前索引的新unique,如果没有取上一个
      // 修改update 返回修改后的节点
      // 当前节点结构 select 返回当前节点，当前索引
      if(type) switch (type) {
        case 'delete': {
          let unique = arr[index] && arr[index].unique
          newNode = {
            unique,
            deleteIndex: index,
            deleteNode: newNode
          }
          arr.splice(index, 1)
          break
        }
        case 'update': {
          arr[index] = updateData
          newNode = arr[index]
          break
        }
        case 'select': {
          let unique = arr[index] && arr[index].unique
          newNode = {
            unique,
            index,
            node: newNode
          }
          break
        }
      }
      break
    } else if(arr[i].leaf && arr[i].leaf.length > 0 && !newNode) {
      newNode = setNode({arr: arr[i].leaf, node: newNode, unique, type, updateData})
    }
  }
  return newNode
}

// 获取当前选中的课程 通过课程唯一标识 unique
export function getObjByCurLesson({
    data = Vuex.state.menusData.blocksForm,
    unique = Vuex.state.menusData.lessonSelected,
    type,
    newData
}) {
  console.log('getObjByCurLesson==>', arguments, data, unique, newData)
  // debugger
  let node = null
  for(let i = 0, len = data.length; i<len; i++){
    if (data[i].leaf && data[i].leaf.length > 0) {
      node = setLessonLeaf({data: data[i].leaf, node, unique, type, newData, parentUnique: data[i].unique})
    } else if (data[i].children && data[i].children.length > 0 && !node) {
      node = setLessonNode({
        data: data[i].children,
        node,
        unique,
        type,
        newData,
        parentUnique: data[i].unique,
        parentNode: data[i]
      })
    } else if (`${data[i].unique}` === `${unique}`) {
      node = data[i]
      break
    }
  }
  return node
}

export function setLessonLeaf({data, node, unique, type, newData, parentUnique}){
  let newNode = node
  for(let i = 0, len = data.length; i < len; i++){
    let leaf = data[i].leaf
    if(leaf && leaf.length > 0 && !newNode){
      newNode = setLessonLeaf({data: data[i].leaf, node: newNode, unique, type, newData, parentUnique: data[i].unique})
    } else if(data[i].children && data[i].children.length > 0 && !newNode) {
      newNode = setLessonNode({data:data[i].children, node: newNode, unique, type, newData, parentUnique: data[i].unique, parentNode: data[i]})
    } else if(`${data[i].unique}` === `${unique}`) {
      newNode = {...data[i], parentUnique}
    }
  }

  return newNode
}

export function setLessonNode({data, node, unique, type, newData, parentUnique, parentNode}){
  let newNode = node
  let index = -1
  for(let i=0, len = data.length; i<len; i++){
    if(`${data[i].unique}` === `${unique}`){
      newNode = data[i]
      index = i

      // type
      // 删除delete 返回删除的索引，当前索引的新unique,如果没有取上一个
      // 修改update 返回修改后的节点
      // 当前节点结构 select 返回当前节点，当前索引
      switch (type) {
        case 'delete': {
          data.splice(index, 1)
          let uniqueNode =  data[index]
          let unique = uniqueNode && uniqueNode.unique
          if (!unique && (index - 1) >= 0) {
            unique = data[index - 1].unique
            uniqueNode = data[index - 1]
          }
          newNode = {
            parentNode,
            unique,
            uniqueNode,
            deleteIndex: index,
            deleteNode: newNode
          }
          break
        }
        case 'update': {
          data[index] = newData
          // console.log('update111==>', unique,  data[index])
          // debugger
          newNode = data[index]
          break
        }
        case 'select': {
          let unique = data[index] && data[index].unique
          newNode = {
            unique,
            index,
            node: newNode,
            parentUnique
          }
          break
        }
      }

      break
    }
  }

  //console.log('setLessonNode==>', data, unique, newNode)
  return newNode
}

// 兼容旧数据 如果name是对象，则转成
// { children: xx,
//   leaf: xx,
//   name: xx,
//   unique: xx
// }
export function getNewMenusData(data) {
  let newData = data
  try {
    if(Array.isArray(newData)) {
      newData = newData.map(v => {
        if (typeof v.name === 'object')
          return {
            ...v,
            ...v.name
          }
      })
    }
  } catch (e) {
    console.log('转换失败==>', e)
  }
  return newData
}

// 获取导航列表
export function getNavList({data}){
  let newData = data || Vuex.state.menusData.blocksForm
  let obj = {}
  if(Array.isArray(newData)) {
    return newData.map(v => {
      obj = {
        key: `${v.unique}`,
        value: v.name
      }
      if (v.leaf && v.leaf.length > 0) {
        obj.children = getLeaf({data: v.leaf})
      }
      return {
        ...obj
      }
    })
  }
}
// 递归导航
export function getLeaf({data}) {
  let obj = {}
  return data.map(v => {
    obj = {
      key: `${v.unique}`,
      value: v.name
    }
    if (v.leaf && v.leaf.length > 0) {
      obj.children = getLeaf({data: v.leaf})
    }
    return obj
  })
}

// 场景引用
// 将场景格式[{xx:xx},{yy:yy}] 改成 {xx:xx, yy:yy}
export function arr2Obj({arr}){
  const obj = {}
  arr.map(v => {
    obj[Object.keys(v)[0]] = Object.values(v)[0]
  })
  return obj
}
// 全部替换场景图
export function setDefaultTheme({data, oldData, md5}){
  // console.log(data, oldData)
  // debugger
  data.map(v=>{
    if (oldData[`${v.name}`]) {
      v.themeMd5 = md5
      v.theme = oldData[`${v.name}`]

      if(v.children && v.children.length>0){
        setTheme({data: v.children, url: oldData[`${v.name}`]})
      }
    } else if (oldData[`${v.unique}`]) {
      v.themeMd5 = md5
      v.theme = oldData[`${v.unique}`]

      if(v.children && v.children.length>0){
        setTheme({data: v.children, url: oldData[`${v.unique}`]})
      }
    }
    if(v.leaf && v.leaf.length>0){
      setDefaultTheme({data: v.leaf, oldData, md5})
    }
  })
}
// 设置场景图
export function setTheme({data, url}){
  data.map(v=>{
    v.theme ={background:{url}}
  })
}

// 获取菜单中的第一张背景图
export function getFirstCover() {
  let data = Vuex.state.menusData.blocksForm
  let cover = ''
  for(let i = 0, len = data.length; i<len; i++){
    if(data[i].leaf && data[i].leaf.length > 0) {
      cover = getFirstLeaf({data: data[i].leaf})
    } else if(data[i].children && data[i].children.length>0){
      cover = getFirstChildren({data:data[i].children})
    }
  }
  return cover
}
export function getFirstLeaf({data}){
  let cover = ''
  for(let i = 0, len = data.length; i < len; i++){
    let leaf = data[i].leaf
    if(leaf && leaf.length > 0){
      cover = getFirstLeaf({data: data[i].leaf})
    } else if(data[i].children && data[i].children.length > 0) {
      cover = getFirstChildren({data:data[i].children})
      if(cover){
        break
      }
    }
  }

  return cover
}
export function getFirstChildren({data}) {
  let cover = ''
  for (let i = 0, len = data.length; i < len; i++) {
    if (data[i] && data[i].theme && data[i].theme.background && data[i].theme.background.url) {
      cover = data[i].theme.background.url
      break
    }
  }
  return cover
}

// 去除树结构中的所有id
export function deleteIdByArr ({ data }) {
  if (!Array.isArray(data)) {
    return data
  }
  data.map(v => {
    if (v.id) {
      delete v.id
      delete v.add
      delete v.edit
      delete v.delete
    }
    if (v.unique) {
      delete v.unique
    }
    if (v.leaf) deleteIdByArr({ data: v.leaf })
  })
  return data
}

// 给树结构赋予对应的序号id
export function addIdByArr ({ parentNode, data, type }) {
  if (!Array.isArray(data)) {
    return data
  }

  console.log('list4==>', data, type)
  data.map((v, i) => {
    if (type || (!v.unique || (data[i] && data[i+1] && `${data[i].unique}` === `${data[i+1].unique}`))) {
      v.unique = Math.random() + Math.random()
    }
    if (parentNode) {
      v.id = `${parentNode.id || '0'}-${i + 1}`
    } else {
      v.id = `${i + 1}`
    }
    if (v.id && v.id.split('-') && v.id.split('-').length >= 3) {
      v.add = false
    } else {
      v.add = true
    }
    v.edit = true
    v.delete = true
    if (v.leaf) addIdByArr({ parentNode: v, data: v.leaf, type })
  })
  return data
}

// 给树结构赋予全新的unique
export function addUniqueByArr ({ data }) {
  if (!Array.isArray(data)) {
    return data
  }

  console.log('list5==>', data)
  data.map(v => {
    v.unique = Math.random() + Math.random()
    if (v.leaf) addUniqueByArr({ data: v.leaf })
    if (v.children) addUniqueByArr({ data: v.children })
  })
  return data
}

// 获取菜单中第一个菜单
export function getFirstMenu({data, unique}) {
  let newData = data
  let newUnique = unique
  for(let i = 0, len = newData.length; i<len; i++){
    if(!newUnique) {
      if (newData[i].leaf && newData[i].leaf.length > 0) {
        newUnique = getFirstMenu({data: newData[i].leaf, unique: newUnique})
      } else {
        newUnique = newData[i].unique
        break
      }
    }
  }
  return newUnique
}

// 判断当前导航中是否存在重复的unique,如果存在重新给每个导航设置新的unique,并设置默认选中菜单级内容
export function calcNavIsUnique({data}) {
  let newData = data
  let list = []
  data.map(v=>{
    list.push(v.unique)
    if(v.leaf && v.leaf.length > 0) {
      list = getUniqueList({list, data: v.leaf})
    }
  })
  /*console.log('list1==>', list)/**/
  if(isRepeat(list)){
    newData = addIdByArr({parentNode: null, data: newData, type: 'over'})

    console.log('list2==>', newData)
  }
  return newData
}

export function getUniqueList({list, data}){
  console.log('list3-0==>', data)
  let newList = list
  let arr = data
  for(let i=0, len = arr.length; i<len; i++) {
    newList.push(arr[i].unique)
    console.log('list3==>', newList)
    if (arr[i].leaf && arr[i].leaf.length > 0) {
      getUniqueList({list: newList,data: arr[i].leaf})
    }
  }
  return newList
}


// 判断数组中是否存在重复
export function isRepeat(arr) {
  let hash = {};
  for(let i in arr) {
    if(hash[`${arr[i]}`]) {
      return true;
    }
    // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
    hash[arr[i]] = true;
  }
  return false;
}


// 获取文件路径扩展名称
export function getExtend ({ url }) {
  let extend = ''
  try {
    const arr = url.split('.')
    const name = arr[arr.length - 1]
    extend = name ? `.${name}` : ''
  } catch (e) {
    console.log('获取文件扩展名失败==>', extend)
  }
  return extend
}

// 根据当前id 获取当前id数据节点
export function getCurNode({id, data}){
  let newData = data
  let node = null
  for(let i = 0, len = newData.length; i<len; i++){
    if(`${newData[i].__trimPathById}` === `${id}`){
      node = newData[i]
      break
    } else if(newData[i].childrens && newData[i].childrens.length > 0 && !node) {
      node = getNode({id, data:newData[i].childrens, node})
    }
  }
  return node
}
// 获取当前id数据节点
export function getNode({id, data, node}){
  let newNode = node
  for(let i=0, len = data.length; i<len; i++){
    if(`${data[i].__trimPathById}` === `${id}`){
      newNode = data[i]
      break
    } else if(data[i].childrens && data[i].childrens.length > 0 && !newNode) {
      newNode = getNode({id, data: data[i].childrens})
    }
  }
  return newNode
}

// 根据当前节点找出所有可以展开的id集
export function getIdsByNode({node}) {
  let arr = []
  if(node.childrens && node.childrens.length>0){
    arr.push(node.__trimPathById)
    getIds({data: node.childrens, arr})
  }
  return arr
}
export function getIds({data, arr}) {
  data.map(v=>{
    if(v.childrens && v.childrens.length>0){
      arr.push(v.__trimPathById)
      getIds({data: v.childrens, arr})
    }
  })
}

// 通过删除id集合 删除当前存在的id
export function deleteIds({deleteIds, ids}) {
  let newIds = ids
  let index = -1
  deleteIds.map(v=>{
    index = newIds.indexOf(v)
    if(index > -1){
      newIds.splice(index, 1)
    }
  })
  return newIds
}

// 通过删除id集合 删除当前存在的id
export function addIds({addIds, ids}) {
  let newIds = ids
  let index = -1
  addIds.map(v=>{
    index = newIds.indexOf(v)
    if(index === -1){
      newIds.push(v)
    }
  })
  return newIds
}

// A数组插入到B数组的某位置中
export function mergeA2B({arrayA, arrayB, indexB}) {
  let arr = JSON.parse(JSON.stringify(arrayB))
  try {
    for(let i = arrayA.length-1; i>-1;i--){
      arr.splice(indexB, 0, arrayA[i])
    }
  } catch (e) {
    console.log('合并失败==>', e)
  }
  return arr
}

// A数组插入到B数组的某位置中
export function mergeA2BTwo({arrayA, arrayB, indexB}) {
  return [...arrayB.slice(0, indexB), ...arrayA, ...arrayB.slice(indexB)]
}

// 重新组装路径参数 {a:1,b:2} 转成 a__1___b__2
export function newQuery(query){
  let result = ''
  try {
    for(let item in query){
      result += `___${item}__${query[item]}`
    }
  } catch (e) {
    console.log('{a:1,b:2} 转成 a__1___b__2参数转换失败==>')
  }
  return result
}

// 重新组装路径参数 a__1___b__2 转成 {a:1,b:2}
export function getQuery(query){
  let result = {}
  try {
    let arr = query.split('___')
    arr.map(v=>{
      if(v){
        result[v.split('__')[0]] = v.split('__')[1]
      }
    })
  } catch (e) {
    console.log('a__1___b__2 转成 {a:1,b:2}参数转换失败==>')
  }
  return result
}

// 重新组装路径参数 {a:1,b:2} 转成 a=1&b=2
export function query2String(query){
  let result = ''
  try {
    for(let item in query){
      result += `&${item}=${query[item]}`
    }
  } catch (e) {
    console.log('{a:1,b:2} 转成 a=1&b=2 参数转换失败==>')
  }
  return result
}

// 将json字符串 转 json
export function jsonStr2Json(json){
  let newJson = json
  try {
    if(typeof newJson === 'string' && newJson.length>1){
      newJson = JSON.parse(newJson)
    }
  } catch (e) {
    console.log('将json字符串 转 json转换失败==>')
  }
  return newJson
}

// 重新给整颗数 设置谓一值
export function setUniqueTree ({ data, parent_id }) {
  if (!Array.isArray(data)) {
    return data
  }
  data.map(v => {
    if(parent_id){
      v.parent_id = parent_id
    }
    v.key = `${v.key}-${parent_id || ''}`
    if (v.children) setUniqueTree({ data: v.children, parent_id: v.key })
  })
  return data
}

// 获取一个字符
export function getZimu ({ unique }) {
  const arr = ['a', 'b', 'c', 'd']
  let newUnique = unique
  arr.map(v=>{
    if(newUnique.indexOf(v) === -1){
      newUnique = newUnique.replace('__', v)
    }
  })
  return newUnique
}

/**
 * 将已有的树型节点字段转换成自己想要的字段格式
 * 例如 {id, name, leaf} => {value, label, children}
 * @param oldKeys | ['leaf', 'id', 'name']
 * @param newKeys | ['children', 'value', 'label']
 * 注意: 数组第一个参数必须是孩子级字段
 */
export function oldTree2NewTree ({ data, oldKeys, newKeys }) {
  let obj = {}
  if(data.length === 0 || !data) return []
  return data.map(v => {
    obj = v
    oldKeys.forEach((q, k) => {
      if (k !== 0) {
        obj[newKeys[k]] = obj[oldKeys[k]]
        delete obj[oldKeys[k]]
      }
    })
    if (v[oldKeys[0]] && v[oldKeys[0]].length > 0) {
      obj[newKeys[0]] = getTreeNewChilrens({ data: v[oldKeys[0]], oldKeys, newKeys })
      delete obj[oldKeys[0]]
    }
    return obj
  })
}
/**
 * 递归树形节点获取所有子节点的数据
 * @param data 数组
 * */
export function getTreeNewChilrens ({ data, oldKeys, newKeys }) {
  let obj = {}
  return data.map(v => {
    obj = v
    oldKeys.forEach((q, k) => {
      if (k !== 0) {
        obj[newKeys[k]] = obj[oldKeys[k]]
        delete obj[oldKeys[k]]
      }
    })
    if (v[oldKeys[0]] && v[oldKeys[0]].length > 0) {
      obj[newKeys[0]] = getTreeNewChilrens({ data: v[oldKeys[0]], oldKeys, newKeys })
      delete obj[oldKeys[0]]
    }
    return obj
  })
}

// 关闭当前浏览器tab
export function closeWindow () {
  window.opener = null
  window.open('', '_self')
  window.location.href = 'about:blank'
  window.close()
}

// 将菜单树 拆成 菜单和课件内容 两颗树
export function one2TwoTree({data, ids}) {
  const menusData = data
  const menusIds = {...ids}

  const setMenusId = arr=>{
    const newArr = []
    arr.map(v=>{
      if(menusIds[v.unique]){
        menusIds[v.unique] = {...menusIds[v.unique], ...JSON.parse(JSON.stringify(v))}
      } else {
        menusIds[v.unique] = JSON.parse(JSON.stringify(v))
      }
      const {unique, type, theme, remark, disabled} = v
      newArr.push({unique, type, theme, remark, disabled})
    })
    return newArr
  }

  function dfs({arr}) {
    if(Array.isArray(arr) && arr.length){
      arr.map(v=>{
        if(menusIds[v.unique]){
          menusIds[v.unique] = {...menusIds[v.unique], ...JSON.parse(JSON.stringify(v))}
        } else {
          menusIds[v.unique] = JSON.parse(JSON.stringify(v))
        }
        let { children, leaf } = v
        if(children && children.length){
          children = setMenusId(children)
        }
        if(leaf && leaf.length){
          dfs({arr:leaf})
        }
      })
    }
  }

  if(menusData.blocksForm && menusData.blocksForm.length){
    dfs({arr:menusData.blocksForm})
    // 删除 lesson
    const clearChild = arr => {
        arr.map(v=>{
            delete v.lesson
            if(v.children && v.children.length){
              v.children.map(q=>delete q.config)
            }
            if(v.leaf){
                clearChild(v.leaf)
            }
        })
        return arr
    }
    clearChild(menusData.blocksForm)
  }

  return {
    menusData,
    menusIds
  }
}
